import { createContext as e } from "react";
//#region src/context/AiChatContext.ts
var t = e(null);
//#endregion
export { t as AiChatContext };
